module.exports = __webpack_public_path__ + "img/kid-head.a5ee503d.png";